export const EXCHANGE_ORDER_INVOICE_SCOPE = 'exchange-order-invoice-email';

export enum EXCHANGE_ORDER_INVOICE_EMAIL {
    SUBJECT = 'SUBJECT',
    CUSTOM_MESSAGE = 'CUSTOM_MESSAGE',
    LINE_ITEMS_EXCHANGE_DISCOUNT = 'LINE_ITEMS_EXCHANGE_DISCOUNT',
    LINE_ITEMS_EXCHANGE_ITEM = 'LINE_ITEMS_EXCHANGE_ITEM',
    EXCHANGE_PAID_AMOUNT = 'EXCHANGE_PAID_AMOUNT'
}